import { IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import heatMap from '../../../../assets/images/information-images/heatMap.png';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface HeatMapModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
}

export const HeatMapModal: React.FC<HeatMapModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.heatMapHeading)}
      onClose={onClose}
      primaryButton={{ label: formatMessage(JobMessages.gotItButton), onClick: onClose }}
    >
      <DqText variant="body">{formatMessage(JobMessages.heatMapInformation)}</DqText>
      <IonRow className="ion-justify-content-center ion-padding">
        <img src={heatMap} alt="clamp diagram" />
      </IonRow>
    </AppModal>
  );
};

export default HeatMapModal;
